import { Progress } from 'antd-v5';
import { createPortal } from 'react-dom';
import EfVideo from 'elem/ui/ef-video';
import EditorLink from 'lowcode/components/EditorLink';
import { useEcoStore } from 'lowcode/utils/context/ecocredits';
import { getLang } from 'lowcomp/plugins/member/utils';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { formatPointsByLocale } from 'lowcomp/plugins/member/utils';
import { TextLang } from '../TextLang';
import DedicatedCustomer from './DedicatedCustomer';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { JoinEcoclubIcon } from '@/components/EcoCredits/Svg';
import { CouponMiniIcon } from '@/components/UI/svg/Ecocredits';
import Button from '@/components/UI/Button';
import EcoCredits from '@/components/UI/svg/Icons/EcoCredits';
import EFArrowRightUp from '@/components/UI/svg/Icons/EFArrowRightUp';
import { getIsShowIcon1 } from '@/service/vip';
import { loginUser } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { onSiteDisplayTimeFormatChange } from '@/utils/timeConversionTool';
import LoginFormModal from '@/components/LoginFormModal';

interface props {
    isLogin?: boolean;
    openModal: (key: string) => void;
    refershData: () => void;
    loginType: 'page' | 'modal';
}

const JoinEcoclub: React.FC<props> = ({ isLogin, openModal, refershData, loginType = 'page' }) => {
    const { locale } = getLocal();
    //const { t } = useLang('ecocredits');
    const t = getLang(TextLang, locale);
    const { rewardUserInfo, rewardUserLevel } = useEcoStore();
    const [href, setHref] = useState('');
    const [username, setUsername] = useState('');
    const [isShowIcon, setIsShowIcon] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showLoginModal1, setShowLoginModal1] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [, setFormatVersion] = useState(0);

    const getSiteFormatFromStorage = () => {
        if (typeof window === 'undefined') return '';
        return (window.localStorage.getItem(`siteDisplayTimeFormat-${locale}`) || '').trim();
    };

    const normalizeDateOnlyFormat = (formatValue: string) => {
        if (!formatValue) return formatValue;
        return formatValue
            .replace(/\s*[Hh]{1,2}(:?mm)?(:?ss)?\s*[Aa]?/g, '')
            .replace(/\s*[Aa]\s*/g, '')
            .replace(/[\s:-]+$/g, '')
            .trim();
    };

    const validTimeStr = (): string => {
        if (!rewardUserLevel || rewardUserLevel.level === 1) return '';
        let format = 'DD/MM/YYYY';
        if (locale === 'kr') {
            format = 'YYYY/MM/DD';
        }
        if (locale === 'jp') {
            format = 'YYYY年MM月DD日';
        }
        if (['us', 'ca', 'eu', 'uk', 'za', 'au'].includes(locale)) {
            format = 'MM DD,YYYY';
        }
        if (locale === 'de') {
            format = 'DD.MM YYYY';
        }
        if (locale === 'it') {
            format = 'MM DD YYYY';
        }
        if (locale === 'es') {
            format = 'DD MM,YYYY';
        }
        const formatFinal = normalizeDateOnlyFormat(getSiteFormatFromStorage() || format);
        const startTime = moment(rewardUserLevel?.validStartTime).format(formatFinal);
        const endTime = moment(rewardUserLevel?.validEndTime).format(formatFinal);
        return `(${startTime} - ${endTime})`;
    };

    useEffect(() => {
        return onSiteDisplayTimeFormatChange(() => {
            setFormatVersion((prev) => prev + 1);
        });
    }, []);

    useEffect(() => {
        const fetchRemoteInfo = async () => {
            const res = await getIsShowIcon1(locale);
            if (res?.code === '0') {
                setIsShowIcon(!!res?.data);
            }
        };
        fetchRemoteInfo();
    }, [locale]);

    useEffect(() => {
        const userInfo = loginUser();
        setIsClient(true);

        try {
            if (userInfo?.token) {
                console.log({ userInfo });
                const email = userInfo?.user.email.split('@')[0];
                const name = userInfo?.user.name;
                setUsername(name || email || '');
            }
        } catch (e) {
            console.log(e);
        }
        setHref(window.location.href);
    }, []);

    return (
        <div
            className={`${styled.JoinEcoclub} ${isLogin ? 'login' : 'unlogin'} GtmModuleData-section`}
            data-section-id={'Member-JoinEcoclub'}
            data-section-title={t('join_title')}
        >
            <div className="bg">
                <EfVideo
                    loop
                    autoPlay
                    pc="https://websiteoss.ecoflow.com/upload/video/1723799567673/PC_2560_640.mp4"
                    h5="https://websiteoss.ecoflow.com/upload/video/1723799582151/m_1024_500.mp4"
                />
                {/* <EFImg pc="https://websiteoss.ecoflow.com/upload/image/1721270272197/ecocredits-kv.jpg" /> */}
            </div>
            <div className="wrapper">
                {isLogin ? (
                    <div className="content login">
                        <p className="member">
                            <span>{t('current_tier')}: </span>
                            <span>
                                {rewardUserLevel?.name}
                                <br />
                                {validTimeStr()}
                            </span>
                        </p>
                        <h1 className="join-title">{t('welcome_title', { username })}</h1>
                        <p className="sub-title">{t('welcome_sub_title')}</p>
                        <p className="join-desc">{rewardUserLevel && rewardUserLevel.level < 2 ? t('welcome_text') : t('welcome_text_plus')}</p>
                    </div>
                ) : (
                    <div className="content unlogin">
                        <h1 className="join-title">{t('join_title')}</h1>
                        <p className="join-desc">{t('join_subTitle')}</p>
                        <div className="action">
                            {loginType === 'modal' ? (
                                <EditorLink
                                    target="_self"
                                    onClick={() => {
                                        signupCookie?.({
                                            sector_name: 'top banner_Join the EcoCredits reward program',
                                            entry_position: 1,
                                        });
                                        setShowLoginModal1(true);
                                    }}
                                >
                                    <Button className="btn register-btn">{t('join_now')}</Button>
                                </EditorLink>
                            ) : (
                                <EditorLink
                                    href={`/${locale}/register?redirect=${encodeURIComponent(href)}`}
                                    target="_self"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'signup_start',
                                        entry_type: 'fixed entry',
                                        entry_name: t('join_title'),
                                        entry_position: 'none',
                                        source_channel: 'Website',
                                    }}
                                    onClick={() =>
                                        signupCookie?.({
                                            sector_name: t('join_title'),
                                            entry_position: 1,
                                        })
                                    }
                                >
                                    <Button className="btn register-btn">{t('join_now')}</Button>
                                </EditorLink>
                            )}
                            {loginType === 'modal' ? (
                                <EditorLink
                                    target="_self"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'activity_join_login',
                                        button_name: 'Join the EcoCredits reward program _Log In',
                                    }}
                                    onClick={() => {
                                        setShowLoginModal(true);
                                    }}
                                >
                                    <Button className="btn login-btn">{t('login')}</Button>
                                </EditorLink>
                            ) : (
                                <EditorLink
                                    href={`/${locale}/login?redirect=${encodeURIComponent(href)}`}
                                    target="_self"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'signup_start',
                                        entry_type: 'fixed entry',
                                        entry_name: t('join_title'),
                                        entry_position: 'none',
                                        source_channel: 'Website',
                                    }}
                                    onClick={() =>
                                        signupCookie?.({
                                            sector_name: t('join_title'),
                                            entry_position: 1,
                                        })
                                    }
                                >
                                    <Button className="btn login-btn">{t('login')}</Button>
                                </EditorLink>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {isLogin && (
                <ul className="summary-content">
                    <li className="summary-content-points">
                        <p className="points-name">{t('points_balance')}</p>
                        <p className="points-value">
                            {formatPointsByLocale(rewardUserInfo?.points, locale)}
                            {/* <i>{t('points')}</i> */}
                        </p>
                    </li>
                    <li className="summary-content-points summary-content-freeze-points">
                        <p className="points-name">{t('coming_soon')}</p>
                        <p className="points-value disabled">
                            {formatPointsByLocale(rewardUserInfo?.frozenPoints, locale)}
                            {/* <i>{t('points')}</i> */}
                        </p>
                    </li>
                    <li className="summary-content-points summary-content-expires-points">
                        <p className="points-name">{t('expires_in_one_month')}</p>
                        <p className="points-value disabled">
                            {formatPointsByLocale(rewardUserInfo?.expiringPoints, locale) || 0}
                            {/* <i>{t('points')}</i> */}
                        </p>
                    </li>
                    <li className="summary-content-action">
                        <EditorLink
                            onClick={() => {
                                openModal('coupon_modal');
                                refershData && refershData();
                            }}
                            className="btn my_rewards"
                        >
                            {t('rewards_redeemed')}
                            {/* <EFArrowRightUp /> */}
                        </EditorLink>
                        <EditorLink
                            onClick={() => {
                                openModal('history_modal');
                                refershData && refershData();
                            }}
                            className="btn my_activity"
                        >
                            {t('points_activity_a')}
                            <EFArrowRightUp />
                        </EditorLink>
                        <EditorLink href={`/${locale}/my-overview`} className="btn my_check_more">
                            {t('check_more')}
                        </EditorLink>
                    </li>
                    {rewardUserLevel && rewardUserLevel.level < 2 && (
                        <li className="summary-content-progress">
                            <Progress percent={((rewardUserInfo?.points || 0) / (rewardUserLevel?.minPoint || 1)) * 100} showInfo={false} size={['100%', 4]} />
                            <span className="progress-numerical">
                                {rewardUserInfo?.points}/{rewardUserLevel?.minPoint}
                            </span>
                            <p className="progress-tips">
                                {t.rich('points_progress_tips', {
                                    plus: rewardUserLevel.plusName,
                                    points: (rewardUserLevel?.minPoint || 0) - (rewardUserInfo?.points || 0),
                                })}
                            </p>
                        </li>
                    )}

                    <li className="summary-content-icon">
                        <JoinEcoclubIcon />
                    </li>
                </ul>
            )}

            {isShowIcon &&
                createPortal(
                    <div className="welfare-center" onClick={() => openModal('bouns_modal')}>
                        <div className="welfare-desc">
                            <span className="welfare-text">{t('grab_title')}</span>
                            <span className="welfare-coupon-icon">
                                <CouponMiniIcon />
                            </span>
                        </div>
                        <div className="welfare-icon">
                            {/* <WelfareIcon /> */}
                            <EcoCredits />
                        </div>
                    </div>,
                    document.querySelector('#Widgets-box-in2-right-id') || document.body,
                )}
            {locale === 'jp' && isLogin && rewardUserLevel?.level === 2 && (
                <div className="dedicated-modal-container">
                    <DedicatedCustomer />
                </div>
            )}
            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}

            {isClient &&
                showLoginModal1 &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal1}
                        onCancel={() => {
                            setShowLoginModal1(false);
                        }}
                        isRegister={true}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </div>
    );
};

export default JoinEcoclub;
